module.exports = __webpack_public_path__ + "img/csbb3@2x.4a4224d1.png";